import { Heading } from 'blaze-ui/Heading/Heading'
import Styles from '../../AutopilotPlansModal.module.scss'

import { Modal } from 'almanac-ui/Modal'
import { IconButton } from 'blaze-ui/IconButton/IconButton'
import { ArrowLeft } from 'blaze-ui/icons'

import { SelectedPlanForm } from './components/SelectedPlanForm/SelectedPlanForm'
import { AutopilotPlan, StripePrice } from 'components/Settings/Workspace/VirtualMarketerUpgradeCta/types'
import { OnStartPlan } from '../../AutopilotPlansModal'
import useResponsiveDesign from 'hooks/useResponsiveDesign'

export const Form = ({
  onBack,
  selectedPlan,
  onStartPlan,
  currentPrice,
  shouldAutoReloadCredits,
  toggleAutoReloadCredits,
}: {
  onBack: () => void
  onStartPlan: OnStartPlan
  selectedPlan: AutopilotPlan
  currentPrice: StripePrice | null
  shouldAutoReloadCredits: boolean
  toggleAutoReloadCredits: () => void
}) => {
  const { isMobile } = useResponsiveDesign()

  return (
    <>
      <Modal.Header preventClose={isMobile}>
        <div className={Styles.header}>
          <div className={Styles.left}>
            <IconButton icon={ArrowLeft} onPress={onBack} variant="tertiary" size="xs" />
            <Heading level={isMobile ? 5 : 3}>Choose your plan length</Heading>
          </div>
        </div>
      </Modal.Header>
      <Modal.Content className={Styles.content} withoutFooter>
        <SelectedPlanForm
          selectedPlan={selectedPlan}
          currentPrice={currentPrice}
          onBack={onBack}
          onStartPlan={onStartPlan}
          shouldAutoReloadCredits={shouldAutoReloadCredits}
          toggleAutoReloadCredits={toggleAutoReloadCredits}
        />
      </Modal.Content>
    </>
  )
}
